import React from "react";

// reactstrap components
// import {
// } from "reactstrap";

// core components
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import IndexHeader from "components/Headers/IndexHeader.js";
import DarkFooter from "components/Footers/DarkFooter.js";

// sections for this page

import Carousel from "./index-sections/Carousel.js";
import CompleteExamples from "./index-sections/CompleteExamples.js";
import Examples from "./index-sections/Examples.js";

function Index(props) {

  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });
  
  return (
    <>
      <IndexNavbar onChange={props.onChange}  user={props.user} productselected={props.productselected} products={props.products} userstatus={props.userstatus} admin={props.admin} />
      <div className="wrapper">
        <IndexHeader />
        <div className="main">
          <Carousel />
          <CompleteExamples info={props.info} admin={props.admin}  onChange={props.onChange}  />
          <Examples onChange={props.onChange}/>
        </div>
        <DarkFooter />
      </div>
    </>
  );
}

export default Index;
